import { FETCH_MYSMELTERS } from '../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_MYSMELTERS:
			return action.payload;
		default:
			return state;
	}
};
